module.exports = __webpack_public_path__ + "static/media/FUN88_Afiliate_Page_QRline2.9ca7d8e1.png";